<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">

        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="给活动起个名字"
          />
        </a-form-item>
        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="4"
            name="keywords"
            placeholder="请输入标签"
            v-decorator="['keywords', { rules: [{ required: true, message: '请输入标签' }] }]"
          />
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="缩略图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="thumb"
            v-decorator="['thumb', { rules: [{ required: true, message: '请上传缩略图' }] }]"
          />
        </a-form-item>
        <a-form-item label="活动日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-range-picker
            showTime
            name="date"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始日期', '结束日期']"
            v-decorator="['date', { rules: [{ required: true, message: '请选择显示日期' }] }]"
          />
        </a-form-item>
        <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="content"
            v-decorator="['content', { rules: [{ required: true, message: '请输入文章内容' }] }]"
          />
        </a-form-item>
        <a-form-item label="活动链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['link', { rules: [{ required: true, message: '请输入活动链接' }] }]"
            name="link"
            placeholder="请输入活动链接"
          />
        </a-form-item>
        <a-form-item label="地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['address', { rules: [{ required: true, message: '请输入地点' }] }]"
            name="address"
            placeholder="请输入地点"
          />
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
          <a-input-number
            name="sort"
            v-decorator="[
              'sort',
              {
                initialValue: 0
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { ImgUpload, UEditor, GoBack } from '@/components'
import { form } from '@/mixins'
const apiList = {
    getInfo: '/activities/',
    create: '/activities/create',
    update: '/activities/'
}
const fields = ['type', 'title', 'keywords', 'desc', 'thumb', 'date', 'content', 'state', 'sort', 'hot', 'link', 'address']

export default {
    name: 'ActForm',
    mixins: [form],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false,
            selectList: []
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.state = values.state === 1
                values.date = [that.moment(values.start_time * 1000), that.moment(values.end_time * 1000)]
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-26 09:26:54
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理表单数据
         * @param  {*}
         * @return {*}
         */
        setFormData (values) {
            values.start_time = this.moment(values.date[0])
            values.end_time = this.moment(values.date[1])
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        }

    }
}
</script>
